import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number };

export const LotusIcon = ({ size = 24, ...props }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M12 22s-8-4.5-8-11a8 8 0 0116 0c0 6.5-8 11-8 11z" />
        <path d="M12 22s3-4.5 3-11a3 3 0 00-6 0c0 6.5 3 11 3 11z" />
        <path d="M12 22v-3" />
        <path d="M7 14c-1.5 0-3-1.5-3-3s1.5-3 3-3" />
        <path d="M17 14c1.5 0 3-1.5 3-3s-1.5-3-3-3" />
    </svg>
);

export const SuryaIcon = ({ size = 24, ...props }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <circle cx="12" cy="12" r="5" fill="currentColor" fillOpacity="0.2" />
        <path d="M12 2v2" />
        <path d="M12 20v2" />
        <path d="M4.93 4.93l1.41 1.41" />
        <path d="M17.66 17.66l1.41 1.41" />
        <path d="M2 12h2" />
        <path d="M20 12h2" />
        <path d="M6.34 17.66l-1.41 1.41" />
        <path d="M19.07 4.93l-1.41 1.41" />
        <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
);

export const ChandraIcon = ({ size = 24, ...props }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill="currentColor" fillOpacity="0.2" />
        <circle cx="16" cy="8" r="1.5" fill="currentColor" />
    </svg>
);

export const StarGeometryIcon = ({ size = 24, ...props }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" fill="currentColor" fillOpacity="0.1" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

/** Ornate SVG corner flourish for framing premium content */
export const CornerFlourish = ({ className = '' }: { className?: string }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" className={className}>
        <path d="M2 30 C2 15 15 2 30 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
        <path d="M6 30 C6 18 18 6 30 6" stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" opacity="0.5" />
        <circle cx="30" cy="2" r="1.5" fill="currentColor" opacity="0.6" />
        <circle cx="2" cy="30" r="1.5" fill="currentColor" opacity="0.6" />
    </svg>
);
